import type { FC, MouseEvent as ReactMouseEvent, ReactNode } from 'react'

import DialogNames from '~/constants/DialogNames'
import DocumentDialogStates from '~/constants/DocumentDialogStates'
import { fileFormat, getFileFormat } from '~/constants/extensions'
import type { Document } from '~/types/entities/documents'
import useDialog from '~/utils/useDialog'

import { AgentLink } from './AgentLink'
import { parseCDNFileLink } from './cdnFileLinkUtils'

export interface CDNFileLinkProps {
  [key: string]: any
  children?: ReactNode
  className?: string
  href: string
  onLinkClick?: () => void
}

export const CDNFileLink: FC<CDNFileLinkProps> = ({
  href,
  children,
  className,
  onLinkClick,
  ...domProps
}) => {
  const [openDocumentDialog] = useDialog(DialogNames.DOCUMENT)
  const { fileExtension, url: cleanedUrl } = parseCDNFileLink(href)
  const format = getFileFormat(fileExtension)

  const handleClick = (e: ReactMouseEvent) => {
    e.preventDefault()
    onLinkClick?.()

    if (format === fileFormat.UNSUPPORTED_FORMAT) {
      window.open(href, '_blank') // open in new tab if extension is unsupported/missing
    } else {
      const documentForPreview: Document = {
        id: 'agent-cdn-file-preview',
        name: 'CDN File Preview',
        extension: fileExtension,
        fileUrl: cleanedUrl,
      }

      openDocumentDialog({
        previewOnly: true,
        document: documentForPreview,
        PreviewProps: {
          hideTopButtons: false,
          view: true,
          isSOAP: false,
          showChangeFile: false,
        },
        step: DocumentDialogStates.PREVIEW,
      })
    }
  }

  return (
    <AgentLink
      className={className}
      href={href}
      {...domProps}
      onClick={handleClick}
    >
      {children}
    </AgentLink>
  )
}
